import { TableCategory } from "interfaces/CategoryInterface";

export function mapCategories(n: TableCategory): TableCategory[] {
  return n.isLeaf ? [n] : [n, ...n.children.map(mapCategories).flat()];
}
